import React, { useEffect, useState } from "react";
import { AppShell } from "./AppShell";
import { getMyProfile } from "../services/profile.service";

/**
 * SectionShell — wraps a legacy section component inside the v2 AppShell
 * so it inherits the sidebar + topbar without rewriting the section itself.
 *
 * Usage:
 *   <SectionShell><Timetable /></SectionShell>
 */
export function SectionShell({ children }) {
  const [profile, setProfile] = useState(null);
  useEffect(() => {
    let m = true;
    getMyProfile().then((p) => m && setProfile(p)).catch(() => {});
    return () => { m = false; };
  }, []);
  return <AppShell user={profile}>{children}</AppShell>;
}
